"use client"

import { useState } from "react"
import { X, Sparkles } from "lucide-react"
import Link from "next/link"

export function AlertBanner() {
  const [dismissed, setDismissed] = useState(false)

  if (dismissed) return null

  return (
    <div className="relative bg-[var(--primary)] text-white animate-slide-down">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-center gap-2 text-[13px] sm:text-sm pr-8">
          <Sparkles size={14} className="text-[var(--mint)] flex-shrink-0 hidden sm:block" />
          <p className="text-center leading-snug">
            <span className="font-medium">We&apos;re back!</span>
            {" "}Things are fresh &amp; still settling in.
            {" "}First 100 sign-ups get a{" "}
            <Link href="/register" className="underline underline-offset-2 font-semibold hover:text-[var(--mint)] transition-colors">
              free year of Pro
            </Link>
            .
            {" "}<span className="hidden sm:inline">Spot something off?{" "}</span>
            <a
              href="mailto:hello@rmar.net"
              className="underline underline-offset-2 hover:text-[var(--mint)] transition-colors"
            >
              <span className="sm:hidden">Feedback?</span>
              <span className="hidden sm:inline">Let us know</span>
            </a>
            {" "}<span className="text-[var(--mint)]">&hearts;</span>
          </p>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/15 transition-colors cursor-pointer"
          aria-label="Dismiss banner"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  )
}
